import { render } from "./AxonLogo.vue?vue&type=template&id=18ab49f4&scoped=true"
import script from "./AxonLogo.vue?vue&type=script&lang=js"
export * from "./AxonLogo.vue?vue&type=script&lang=js"

import "./AxonLogo.vue?vue&type=style&index=0&id=18ab49f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ab49f4"]])

export default __exports__